import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import "../styles/UniversalPageHeader.css";

export default function UniversalPageHeader({ title, subtitle, actions }) {
  return (
    <div className="universal-header">
      <div className="header-content">
        <h1>{title}</h1>
        {subtitle && <h2>{subtitle}</h2>}
        <div className="actions">
          {actions &&
            actions.map((action, index) => (
              <Link key={index} to={action.link} className="action-button">
                {action.actionTitle}
              </Link>
            ))}
        </div>
      </div>
    </div>
  );
}

UniversalPageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string.isRequired,
      actionTitle: PropTypes.string.isRequired,
    })
  ),
};

UniversalPageHeader.defaultProps = {
  subtitle: "",
  actions: [],
};
